import { motion } from 'motion/react';
import { Link } from 'react-router-dom';

export default function PhilosophyPage() {
  return (
    <div className="min-h-screen pt-32 pb-24 bg-theme-bg">
      <div className="max-w-7xl mx-auto px-6">
        <header className="mb-24 text-center">
            <span className="kicker">The Manifesto</span>
            <h1 className="md:text-7xl leading-none">
                Architecture, Not Emotion.
            </h1>
            <div className="w-px h-24 bg-gold/50 mx-auto" />
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-24 items-start mb-32">
            <div>
                <h2 className="text-sm uppercase tracking-[0.3em] text-gold mb-8">The Core Thesis</h2>
                <div className="space-y-8 text-lg font-light leading-relaxed italic text-theme-text/90">
                    <p>
                        She Deserves Better (SDB) was founded on a singular architectural realization: Most women manage their highest-stake relationships through emotional intuition rather than structural planning.
                    </p>
                    <p>
                        In a world where assets are protected by ironclad contracts and skyscrapers are held up by precise mathematical models, why is the romantic foundation of a powerful woman left to chance?
                    </p>
                    <p>
                        We provide the clinical blueprint. We provide the architectural oversight. We provide the exit strategies and the expansion plans.
                    </p>
                </div>
            </div>
            <div className="relative aspect-square overflow-hidden border border-taupe/20">
                <img
                  src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&q=80&w=1000"
                  alt="Architecture"
                  className="w-full h-full object-cover grayscale"
                  referrerPolicy="no-referrer"
                />
            </div>
        </div>

        <section className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-serif italic mb-12 text-center">The Three Pillars</h2>
            <div className="space-y-16">
                {[
                    {
                        title: "Discretion as Currency",
                        desc: "Information is the most volatile asset. We teach members how to maintain absolute privacy while navigating high-stakes social and romantic environments."
                    },
                    {
                        title: "Structural Autonomy",
                        desc: "A relationship is a partnership, not a merger. We ensure every member maintains their independent structural integrity, regardless of the union's scale."
                    },
                    {
                        title: "Vetted Excellence",
                        desc: "Mediocrity is a structural flaw. We curate only the highest-status resources, connections, and advice, ensuring your environment reflects your standard."
                    }
                ].map((pillar, i) => (
                    <div key={i} className="flex flex-col md:flex-row gap-8 items-start">
                        <span className="text-2xl font-serif text-gold">0{i + 1}</span>
                        <div>
                            <h3 className="text-xl font-serif italic mb-4">{pillar.title}</h3>
                            <p className="text-taupe leading-relaxed font-light">{pillar.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>

        <div className="mt-32 text-center">
             <div className="divider" />
             <p className="text-[10px] uppercase tracking-[0.5em] text-taupe mt-12 mb-8 italic">Excellence is a Choice. Architecture is the Tool.</p>
             <Link to="/auth" className="btn-gold inline-block">Join the Briefing</Link>
        </div>
      </div>
    </div>
  );
}
